__turbopack_context__.v({
  "avatar": "ProducerSelectModal-module-scss-module__DB1YpW__avatar",
  "content": "ProducerSelectModal-module-scss-module__DB1YpW__content",
  "info": "ProducerSelectModal-module-scss-module__DB1YpW__info",
  "modal": "ProducerSelectModal-module-scss-module__DB1YpW__modal",
  "producer": "ProducerSelectModal-module-scss-module__DB1YpW__producer",
  "title": "ProducerSelectModal-module-scss-module__DB1YpW__title",
  "toggle-wrapper": "ProducerSelectModal-module-scss-module__DB1YpW__toggle-wrapper",
});
